import { color } from 'csx';
import { initializeNotification } from './../components/Notification/Notification';
import popverCss from './popover.css';
import topography from './typography.css';
export function removeObjectProperties(obj, ...props) {
    obj = Object.assign({}, obj);
    for (let i = 0; i < props.length; i++) {
        if (obj.hasOwnProperty(props[i])) {
            delete obj[props[i]];
        }
    }
    return obj;
}
export function nestedAccess(obj, ...props) {
    return obj && props.reduce((result, prop) => (result == null ? undefined : result[prop]), obj);
}
export function getColor(clr, black = '#555555', white = '#ffffff') {
    return color(clr).lightness() > 0.7 ? black : white;
}
export function initialize() {
    const style = document.createElement('style');
    style.id = 'sha-el-design-base-style';
    style.innerHTML = `
    body {
      background: var(--background);
      color: var(--color);
      margin: 0;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      -webkit-overflow-scrolling: touch;
    }
    a, a:hover, a:focus, a:active {
      text-decoration: none;
      color: var(--color);
    }
    svg {
      display: flex;
    }
    @import url('https://fonts.googleapis.com/css2?family=Montserrat+Alternates:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,400&display=swap');
    @import url('https://fonts.googleapis.com/css?family=Fira+Code:300,400,500,600,700&display=swap');
    ${popverCss}
    ${topography}
  `;
    document.getElementsByTagName('head')[0].appendChild(style);
    initializeNotification();
}
export function arrayBetween(num1, num2) {
    const arr = [];
    for (let i = num1; i < num2; i++) {
        arr.push(i);
    }
    return arr;
}
export const isBrowser = () => typeof window !== 'undefined' && typeof window.document !== 'undefined';
export function getRandomColor() {
    const letters = '0123456789ABCDEF';
    let col = '#';
    for (let i = 0; i < 6; i++) {
        col += letters[Math.floor(Math.random() * 16)];
    }
    return col;
}
export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export const setAttribute = (obj, value, propPath) => {
    const [head, ...rest] = propPath;
    const checkForNumber = () => {
        if (isNaN(Number(head))) {
            return head;
        }
        return Number(head);
    };
    !rest.length ? (obj[checkForNumber()] = value) : setAttribute(obj[checkForNumber()], value, rest);
};
export const classes = (...args) => args.filter((v) => !!v).join(' ');
//# sourceMappingURL=index.js.map